export { default as Headings } from './Headings';
